import { saveCsListView, CsListView } from "../../utils/user_view_prefs";

export function bindCsListFrame(): void {
  document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;

    const hide = target.closest("[data-cs-metrics-hide]");
    if (hide) {
      const metrics = hide.closest<HTMLElement>("[data-cs-metrics]");
      if (metrics) metrics.hidden = true;
      return;
    }

    const viewLink = target.closest<HTMLElement>("[data-cs-view]");
    if (viewLink) saveCsListView({ view: viewLink.dataset.csView as CsListView["view"] });
  });
}
